import { useEffect, useState } from 'react';
import { useSubstate } from 'use-substate';

import { client, useErrorNotifications } from 'core/http';
import { SetCustomerServices } from 'core/Store/customerServices/actions';
import { selectCustomerServicesById } from 'core/Store/customerServices/selectors';
import { Service } from 'core/types/service';

export default function useCustomerServices(customerId: number) {
  const showErrorNotification = useErrorNotifications();
  const [services, dispatch] = useSubstate(
    selectCustomerServicesById(customerId)
  );
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customerId) return;

    setLoading(true);

    client()
      .get<Array<Service & { pivot: { price: number } }>>(
        `customers/${customerId}/services`
      )
      .then((response) => response.data)
      .then((services) =>
        dispatch(new SetCustomerServices(customerId, services))
      )
      .catch(showErrorNotification)
      .finally(() => setLoading(false));
  }, [customerId, dispatch, showErrorNotification]);

  return { services, loading };
}
